import BaseService from '@/services/base-service'
import { Stores } from 'package-types'

export default {
  async getStore(storeId: string): Promise<Stores.Actions.GetStoreResult> {
    const { data } = await BaseService.get(`/stores/store/${storeId}`)
    return data
  }
}
